import { render, staticRenderFns } from "./image-upload-v2.vue?vue&type=template&id=88fff184&scoped=true&"
import script from "./image-upload-v2.vue?vue&type=script&lang=js&"
export * from "./image-upload-v2.vue?vue&type=script&lang=js&"
import style0 from "./image-upload-v2.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./image-upload-v2.vue?vue&type=style&index=1&id=88fff184&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88fff184",
  null
  
)

export default component.exports
import {QIcon,QImg} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QIcon,QImg})
